module.exports = __webpack_public_path__ + "static/media/show_world.74018bea.png";